"use strict";
// import { z } from 'zod';
Object.defineProperty(exports, "__esModule", { value: true });
// import { ISODateTimeSchema, UUIDSchema } from '../shared';
// export const JobOfferreminderTemplateSchema = z.object({
// 	id:        UUIDSchema,
// 	name:      z.string(),
// 	message:   z.string(),
// 	subject:   z.string(),
// 	createdAt: ISODateTimeSchema,
// 	updatedAt: ISODateTimeSchema,
// });
// export type OfferReminderTemplate = z.infer<typeof JobOfferreminderTemplateSchema>;
